export const SIGNIN_USER = 'signin_user';
export const SIGNUP_USER = 'signup_user';
export const AUTH_USER = 'auth_user';
export const SIGNOUT_USER = 'signout_user';
